import { gql, useQuery } from "@apollo/client";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { Category } from "../../components/category";
import { CATEGORY_FRAGMENT } from "../../fragments";
import { allCategoriesQuery } from "../../__generated__/allCategoriesQuery";


const CATEGORIES_QUERY = gql`
  query allCategoriesQuery {
    allCategories {
      ok
      error
      categories {
        ...CategoryParts
      }
    }
  }
  
  ${CATEGORY_FRAGMENT}
`;

export const Categories = () => {

  const { data, loading } = useQuery<
    allCategoriesQuery
  >(CATEGORIES_QUERY, {
    variables: {
    },
  });


  return <div>
    <Helmet>
      <title>All Categories | KUDOK</title>
    </Helmet>
    <div className="max-w-screen-2xl mx-auto flex flex-col pb-96 pt-24">
      <div className="pl-10">
        <h2 className="text-4xl font-medium mb-10 pt-12 ">All Categories</h2>
        {!loading && (
          <div className="grid mt-16 md:grid-cols-3 gap-x-5 gap-y-10">
            {data?.allCategories.categories.map((category) => (
              <Category
                key={Math.random() + category.id}
                slug={category.slug}
                coverImage={category.coverImage}
                name={category.name}
                podcastCount={category.podcastCount}
                createdAt={category.createdAt}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  </div>;
};